import React from 'react'
import PropTypes from 'prop-types'
import { Card, CardBody, CardTitle, Form } from 'reactstrap'
import FormField from '../components/FormField'

const StandardForm = ({
  title,
  description,
  fields,
  values,
  errors,
  handleChange,
  t,
  children
}) => {
  return (
    <Card className="mb-4">
      <CardBody>
        <CardTitle className="h4">{t(title)}</CardTitle>
        {description && (
          <p className="card-title-desc">{t(description)}</p>
        )}
        {fields.some(f => f.required) && (
          <p className="text-muted small mb-3"><span className="text-danger">*</span> {t('Required field')}</p>
        )}

        <Form onSubmit={(e) => e.preventDefault()}>
          {fields.map(field => (
            <FormField
              key={field.name}
              label={t(field.label)}
              name={field.name}
              type={field.type}
              value={values[field.name]}
              onChange={field.onChange || handleChange}
              error={errors[field.name]}
              placeholder={field.placeholder ? t(field.placeholder) : undefined}
              required={field.required}
              disabled={field.disabled}
              options={field.options?.map(opt => ({
                value: opt.value,
                label: t(opt.label)
              }))}
              onAddressChange={field.onAddressChange}
              {...field.props}
            />
          ))}
          {children}
        </Form>
      </CardBody>
    </Card>
  )
}

StandardForm.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  fields: PropTypes.array.isRequired,
  values: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
  handleChange: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
  children: PropTypes.node
}

export default StandardForm